import { useToastError } from "@/components/ui/use-toast";
import { useTranslation } from "@/hooks/useTranslation";
import { getApiErrorCode } from "@/lib/api-error";

/** Maps backend license error codes to their i18n key suffix. */
const ERROR_CODE_TO_KEY: Record<string, string> = {
  INSUFFICIENT_STOCK: "insufficientStock",
  CONCURRENT_LICENSE_OPERATION: "concurrentOperation",
  IDEMPOTENT_REQUEST_IN_FLIGHT: "concurrentOperation",
  PAYMENT_REQUIRED_BEFORE_INCREASE: "paymentRequiredBeforeIncrease",
  INVOICE_OVERDUE_BEFORE_INCREASE: "invoiceOverdueBeforeIncrease",
  IDEMPOTENT_RESULT_UNAVAILABLE: "idempotentResultUnavailable",
};

/**
 * Returns a handler that shows a specific toast for known license API error
 * codes (insufficient stock, concurrent operation, payment required,
 * idempotent result unavailable) and falls back to the generic error toast.
 */
export const useLicenseErrorToast = (): ((error: unknown) => void) => {
  const { t } = useTranslation();
  const toastError = useToastError();

  return (error: unknown) => {
    const code = getApiErrorCode(error);
    const key = code ? ERROR_CODE_TO_KEY[code] : undefined;
    if (!key) {
      toastError();
      return;
    }
    toastError({
      title: t(`team.licenseManagement.errors.${key}.title`),
      description: t(`team.licenseManagement.errors.${key}.description`),
    });
  };
};
